exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container[data-v-3d83e014]  .custom-tab-list {\n  padding: 0 20px;\n}\n.main-container[data-v-3d83e014]  .tab-content {\n  margin-top: 30px;\n}\n", ""]);

// exports
